import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u06A9\u0648\u0631\u062F\u06CC",
  code: "ckb",
  dir: "rtl",
  messages: {
    alert: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646"
    },
    authForm: {
      hidePassword: "\u0634\u0627\u0631\u062F\u0646\u06D5\u0648\u06D5\u06CC \u0648\u0634\u06D5\u06CC \u0646\u0647\u06CE\u0646\u06CC",
      showPassword: "\u067E\u06CC\u0634\u0627\u0646\u062F\u0627\u0646\u06CC \u0648\u0634\u06D5\u06CC \u0646\u0647\u06CE\u0646\u06CC",
      submit: "\u0628\u06D5\u0631\u062F\u06D5\u0648\u0627\u0645 \u0628\u06D5"
    },
    banner: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646"
    },
    calendar: {
      nextMonth: "\u0645\u0627\u0646\u06AF\u06CC \u062F\u0627\u0647\u0627\u062A\u0648\u0648",
      nextYear: "\u0633\u0627\u06B5\u06CC \u062F\u0627\u0647\u0627\u062A\u0648\u0648",
      prevMonth: "\u0645\u0627\u0646\u06AF\u06CC \u067E\u06CE\u0634\u0648\u0648",
      prevYear: "\u0633\u0627\u06B5\u06CC \u067E\u06CE\u0634\u0648\u0648"
    },
    carousel: {
      dots: "\u0633\u0644\u0627\u06CC\u062F\u06CE\u06A9 \u0647\u06D5\u06B5\u0628\u0698\u06CE\u0631\u06D5 \u0628\u06C6 \u067E\u06CC\u0634\u0627\u0646\u062F\u0627\u0646",
      goto: "\u0628\u0695\u06C6 \u0628\u06C6 \u0633\u0644\u0627\u06CC\u062F\u06CC {slide}",
      next: "\u062F\u0627\u0647\u0627\u062A\u0648\u0648",
      prev: "\u067E\u06CE\u0634\u0648\u0648\u06CC"
    },
    chatPrompt: {
      placeholder: "\u0647\u06D5\u06B5\u06D5\u06CC\u06D5\u06A9 \u0644\u06D5\u0633\u06D5\u0631 \u0686\u0627\u067E\u06D5\u06A9\u06D5\u062A \u0628\u0646\u0648\u0648\u0633\u06D5..."
    },
    chatPromptSubmit: {
      label: "\u067E\u06CE\u0686\u06D5\u0648\u06D5"
    },
    colorMode: {
      dark: "\u062A\u0627\u0631\u06CC\u06A9",
      light: "\u0695\u0648\u0648\u0646\u0627\u06A9",
      switchToDark: "\u06AF\u06C6\u0695\u06CC\u0646 \u0628\u06C6 \u062F\u06C6\u062E\u06CC \u062A\u0627\u0631\u06CC\u06A9",
      switchToLight: "\u06AF\u06C6\u0695\u06CC\u0646 \u0628\u06C6 \u062F\u06C6\u062E\u06CC \u0695\u0648\u0648\u0646\u0627\u06A9",
      system: "\u0633\u06CC\u0633\u062A\u06D5\u0645"
    },
    commandPalette: {
      back: "\u06AF\u06D5\u0695\u0627\u0646\u06D5\u0648\u06D5",
      close: "\u062F\u0627\u062E\u0633\u062A\u0646",
      noData: "\u0647\u06CC\u0686 \u062F\u0627\u062A\u0627\u06CC\u06D5\u06A9 \u0646\u06CC\u06CC\u06D5",
      noMatch: "\u0647\u06CC\u0686 \u0626\u06D5\u0646\u062C\u0627\u0645\u06CE\u06A9 \u0646\u06D5\u062F\u06C6\u0632\u0631\u0627\u06CC\u06D5\u0648\u06D5",
      placeholder: "\u0641\u06D5\u0631\u0645\u0627\u0646\u06CE\u06A9 \u0628\u0646\u0648\u0648\u0633\u06D5 \u06CC\u0627\u0646 \u0628\u06AF\u06D5\u0695\u06CE..."
    },
    contentSearch: {
      links: "\u0628\u06D5\u0633\u062A\u06D5\u0631\u06D5\u06A9\u0627\u0646",
      theme: "\u0695\u0648\u0648\u06A9\u0627\u0631"
    },
    contentSearchButton: {
      label: "\u06AF\u06D5\u0695\u0627\u0646..."
    },
    contentToc: {
      title: "\u0644\u06D5\u0645 \u067E\u06D5\u0695\u06D5\u06CC\u06D5\u062F\u0627"
    },
    dashboardSearch: {
      theme: "\u0695\u0648\u0648\u06A9\u0627\u0631"
    },
    dashboardSearchButton: {
      label: "\u06AF\u06D5\u0695\u0627\u0646..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u062F\u0627\u062E\u0633\u062A\u0646\u06CC \u0644\u0627\u06CC \u062A\u06D5\u0646\u06CC\u0634\u062A",
      expand: "\u0641\u0631\u0627\u0648\u0627\u0646\u06A9\u0631\u062F\u0646\u06CC \u0644\u0627\u06CC \u062A\u06D5\u0646\u06CC\u0634\u062A"
    },
    dashboardSidebarToggle: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646\u06CC \u0644\u0627\u06CC \u062A\u06D5\u0646\u06CC\u0634\u062A",
      open: "\u06A9\u0631\u062F\u0646\u06D5\u0648\u06D5\u06CC \u0644\u0627\u06CC \u062A\u06D5\u0646\u06CC\u0634\u062A"
    },
    error: {
      clear: "\u06AF\u06D5\u0695\u0627\u0646\u06D5\u0648\u06D5 \u0628\u06C6 \u0633\u06D5\u0631\u06D5\u062A\u0627"
    },
    fileUpload: {
      removeFile: "{filename} \u0628\u0633\u0695\u06D5\u0648\u06D5"
    },
    header: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646\u06CC \u067E\u06CE\u0695\u0633\u062A",
      open: "\u06A9\u0631\u062F\u0646\u06D5\u0648\u06D5\u06CC \u067E\u06CE\u0695\u0633\u062A"
    },
    inputMenu: {
      create: '"{label}" \u062F\u0631\u0648\u0633\u062A\u06A9\u0631\u062F\u0646\u06CC',
      noData: "\u0647\u06CC\u0686 \u062F\u0627\u062A\u0627\u06CC\u06D5\u06A9 \u0646\u06CC\u06CC\u06D5",
      noMatch: "\u0647\u06CC\u0686 \u0626\u06D5\u0646\u062C\u0627\u0645\u06CE\u06A9 \u0646\u06D5\u062F\u06C6\u0632\u0631\u0627\u06CC\u06D5\u0648\u06D5"
    },
    inputNumber: {
      decrement: "\u06A9\u06D5\u0645\u06A9\u0631\u062F\u0646\u06D5\u0648\u06D5",
      increment: "\u0632\u06CC\u0627\u062F\u06A9\u0631\u062F\u0646"
    },
    modal: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646"
    },
    pricingTable: {
      caption: "\u0695\u06CE\u0686\u0648\u0648\u06CC \u067E\u06D5\u06CC\u06A9\u06D5\u0631\u062F\u0627\u0646"
    },
    prose: {
      codeCollapse: {
        closeText: "\u062F\u0627\u062E\u0633\u062A\u0646",
        name: "\u06A9\u06C6\u062F",
        openText: "\u0641\u0631\u0627\u0648\u0627\u0646\u06A9\u0631\u062F\u0646"
      },
      collapsible: {
        closeText: "\u0634\u0627\u0631\u062F\u0646\u06D5\u0648\u06D5",
        name: "\u062A\u0627\u06CC\u0628\u06D5\u062A\u0645\u06D5\u0646\u062F\u06CC\u06CC\u06D5\u06A9\u0627\u0646",
        openText: "\u067E\u06CC\u0634\u0627\u0646\u062F\u0627\u0646"
      },
      pre: {
        copy: "\u0644\u06D5\u0628\u06D5\u0631\u06AF\u0631\u062A\u0646\u06D5\u0648\u06D5\u06CC \u06A9\u06C6\u062F"
      }
    },
    selectMenu: {
      create: '"{label}" \u062F\u0631\u0648\u0633\u062A\u06A9\u0631\u062F\u0646\u06CC',
      noData: "\u0647\u06CC\u0686 \u062F\u0627\u062A\u0627\u06CC\u06D5\u06A9 \u0646\u06CC\u06CC\u06D5",
      noMatch: "\u0647\u06CC\u0686 \u0626\u06D5\u0646\u062C\u0627\u0645\u06CE\u06A9 \u0646\u06D5\u062F\u06C6\u0632\u0631\u0627\u06CC\u06D5\u0648\u06D5",
      search: "\u06AF\u06D5\u0695\u0627\u0646..."
    },
    slideover: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646"
    },
    table: {
      noData: "\u0647\u06CC\u0686 \u062F\u0627\u062A\u0627\u06CC\u06D5\u06A9 \u0646\u06CC\u06CC\u06D5"
    },
    toast: {
      close: "\u062F\u0627\u062E\u0633\u062A\u0646"
    }
  }
});
